import React from "react"
import {Button, Typography} from "@mui/material";
import CCOLinkText from "../../fundamentals/CCOLinkText";
import {buttonStyle} from "../../../common/constants/buttonStyle";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import {useTranslation} from "react-i18next";

export enum CallToActionType {
    TEXT,
    BUTTON,
}

interface Props {
    item: any
    callToActionType?: CallToActionType
    callToActionCustomText?: string
}

function TeaserCardCallToAction(props: Props) {
    const {t} = useTranslation();
    switch (props.callToActionType) {
        case CallToActionType.TEXT:
            return renderCallToActionText(props, t);
        case CallToActionType.BUTTON:
            return renderCallToActionButton(props, t);
        default:
            return null;
    }
}

function renderCallToActionText(props: Props, t: any) {
    return <CCOLinkText txt={props.callToActionCustomText || t('coo_learn_more')} hasFocusedStyle/>;
}

function renderCallToActionButton(props: Props, t: any) {
    const openInNewTab =  props.item?.teaserTarget?.openInNewTab;
    const colorStyle = buttonStyle[props.item?.teaserSettings?.callToActionButtonColor] || buttonStyle['green'];
    return <CCOLinkable target={props.item.teaserTarget} noLinkIcon openInTab={openInNewTab}>
        <Button type='submit' variant='contained' sx={{mb: 1, ...colorStyle}}>
            <Typography variant='ctaButton'>
                {props.callToActionCustomText || t('c014_default_call_to_action_text')}
            </Typography>
        </Button>
    </CCOLinkable>
}

export default TeaserCardCallToAction


